document.addEventListener("DOMContentLoaded", function() {

    // const imgs = document.querySelectorAll('img, svg, picture');
    // imgs.forEach(function(img) {
    //     img.addEventListener("contextmenu", function (e) {
    //         e.preventDefault ();
    //     });
    // });
    document.addEventListener("contextmenu", function (e) {
        if(e.target.tagName == 'IMG' || e.target.tagName == 'SVG' || e.target.tagName == 'PICTURE') {
            e.preventDefault();
        }
    });

    const moreBtn = document.querySelector('.home-cols-more');
    if(moreBtn) {
        moreBtn.onclick = function() {
            document.querySelector('.home-cols-additional').classList.remove('hidden');
            document.querySelector('.home-cols-more-wrap').style.display = 'none';
        }
    }
    
    const dialog = document.querySelector('.select-vehicle-dialog'),
          dialogClose = dialog.querySelector('.dialog__close'),
          dialogBtns = document.querySelectorAll('.header__btn');
    
    dialogBtns.forEach(function(btn) {
        btn.onclick = function() {
            dialog.showModal();
        }
    });

    window.onclick = function(event) {
        if (dialog.open && event.target.closest('dialog') && !event.target.closest('dialog .shopify-app-block')) {
            dialog.close();
        }
    }

    dialogClose.onclick = function() {
        dialog.close();
    }


    const collapsibles = document.querySelectorAll('.footer__collapsible');
    const collapsibleTriggers = document.querySelectorAll('.footer__collapsible-trigger');

    collapsibleTriggers.forEach(function(trigger) {
        trigger.onclick = function() {
            const collapsible = trigger.nextElementSibling;
            if(collapsible.classList.contains('hidden')) {
                collapsible.classList.remove('hidden');
                trigger.classList.add('active');
            } else {
                collapsible.classList.add('hidden');
                trigger.classList.remove('active');
            }
        }
    });

    window.addEventListener('resize', throttle(function() {
        if (window.innerWidth > 768) {
            collapsibles.forEach(function(collapsible) {
                collapsible.classList.remove('hidden');
            });
            collapsibleTriggers.forEach(function(trigger) {
                trigger.classList.remove('active');
            });
        } else {
            collapsibles.forEach(function(collapsible) {
                if(collapsible.previousElementSibling.classList.contains('is_open')) return;

                collapsible.classList.add('hidden');
            });
            collapsibleTriggers.forEach(function(trigger) {
                if(trigger.classList.contains('is_open')) return;
                    
                trigger.classList.remove('active');
            });
        }

        const isOpnenCollapsible = document.querySelectorAll('.footer__collapsible-trigger.is_open');

        // isOpnenCollapsible.click();
        isOpnenCollapsible.forEach(element => { 
            console.log("🚀 ~ file: custom.js:60 ~ document.addEventListener ~ element:", element)
            element.click(); 
            element.dispatchEvent(new Event('click'));
        });


    }, 300));

    setTimeout(function() {
        window.dispatchEvent(new Event('resize'));
    }, 500);


    function throttle(fn, wait) {
        var time = Date.now();
        return function() {
            if ((time + wait - Date.now()) < 0) {
                fn();
                time = Date.now();
            }
        }
    }


});